
import React, { useEffect, useRef } from 'react';
import img1 from '../img/logo/New folder/IMG-20241127-WA0001.jpg';
import img2 from '../img/logo/New folder/IMG-20241127-WA0003.jpg';
import img3 from '../img/aaaservices/12_SARANYA.jpg';
import img4 from '../img/logo/New folder/IMG-20241127-WA0002 (1).jpg';

import naveen from '../img/aaaservices/navven.jpg';
import pchnanda from '../img/aaaservices/chandbasa.jpg';
import subryamnanyam from '../img/aaaservices/subramnyam.jpg';
import meeraImage from '../img/aaaservices/Nareshsir.jpg';
import Navaneeth from '../img/aaaservices/nawneet.jpg';
import rahulImage1 from '../img/aaaservices/SAVE_20230519_121324.jpg.jpeg';
import rahulImage2 from '../img/aaaservices/vikash.png';
import rahulImage3 from '../img/aaaservices/mahesh.jpg';
import rahulImage4 from '../img/aaaservices/vamshi.jpeg';
import rahulImage5 from '../img/aaaservices/satish.jpg';
import rahulImage6 from '../img/aaaservices/nag.png';
import sudheer from '../img/aaaservices/sudheer.jpg'
import avishek from '../img/aaaservices/avishek.jpg'

import logoImage from '../img/banner/Picture2.png';

const coaches = [
 {
  name: "Naveen",
  title: "Mechanical Engineer",
  subheading: "Improved my practical skills through hands-on mechanical projects.",
  image: naveen,
},
{
  name: "P. Chand Basha",
  title: "Mechanical Engineer",
  subheading: "Great learning environment with strong focus on real-world applications.",
  image: pchnanda,
},
{
  name: "Subramanyam",
  title: "Mechanical Engineer",
  subheading: "Helped me build confidence in industrial tools and techniques.",
  image: subryamnanyam,
},
{
  name: "Navaneeth",
  title: "Mechanical Design Engineer",
  subheading: "Enhanced my design skills with practical CAD and automation exposure.",
  image: Navaneeth,
},

  // Updated & New Entries
  {
    name: "Naresh Bojja",
    title: "Full-Stack Developer",
    subheading: "Skilled in both frontend and backend technologies.",
    image: meeraImage,
  },
  {
    name: "Vikash Singh",
    title: "Full-Stack Developer",
    subheading: "Experienced in building complete web applications.",
    image: rahulImage2,
  },
  {
    name: "Jai Sivapavan",
    title: "Web Developer",
    subheading: "Focused on creating responsive and user-friendly websites.",
    image: rahulImage1,
  },
  {
    name: "Mahesh Bonthala",
    title: "Flutter Developer",
    subheading: "Specialized in building cross-platform mobile applications.",
    image: rahulImage3,
  },
  {
    name: "VamshiKrishna Kukkala",
    title: "Backend Developer",
    subheading: "Experienced in server-side logic and database management.",
    image: rahulImage4,
  },
  {
    name: "Satish Ghanta",
    title: "Backend Developer",
    subheading: "Focused on scalable and efficient backend systems.",
    image: rahulImage5,
  },
  {
    name: "Koppula Nagaraj",
    title: "Flutter Developer",
    subheading: "Passionate about modern mobile app development.",
    image: rahulImage6,
  },
  {
    name: "Mulinti Abhishek",
    title: "Flutter Developer",
    subheading: "Experienced in building high-performance mobile apps.",
    image: avishek,
  },
  {
    name: "Goddumarri Sudheer Kumar",
    title: "Web Developer",
    subheading: "Focused on modern web technologies and UI development.",
    image: sudheer,
  },
];



const CoachProfiles = () => {
  const carouselRef = useRef(null);
  useEffect(() => {
    const carousel = carouselRef.current;
    let scrollAmount = 0;
    const speed = 1;
    let animationFrameId;

    const step = () => {
      if (!carousel) return;
      scrollAmount += speed;
      if (scrollAmount >= carousel.scrollWidth / 2) {
        scrollAmount = 0;
      }
      carousel.scrollLeft = scrollAmount;
      animationFrameId = requestAnimationFrame(step);
    };

    animationFrameId = requestAnimationFrame(step);
    return () => cancelAnimationFrame(animationFrameId);
  }, []);

  const displayCoaches = [...coaches, ...coaches];

  return (
    <div style={styles.wrapper}>
      <p style={{
          textAlign: 'center',
          fontSize: '48px',
          fontWeight: 'bold',
          margin: '8px 0',
          marginTop:'-30px',
          fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", "SF Pro Display", "Helvetica Neue", Helvetica, Arial, sans-serif'
        }}>
          <span style={{ color: 'white' }}>Our </span>
          <span style={{ color: 'rgb(247 148 29)' }}>learners</span>
        </p>

      <div ref={carouselRef} className="carousel">
        {displayCoaches.map((card, index) => (
          <div key={index} style={styles.card} className="card">
            <img src={card.image} alt={card.name} className="card-img" />
            <div className="text-overlay">
  <button className="info-button">
    <div className="info-header">
      <h3 style={{fontSize:'20px',color:'blue',fontFamily:'sans,serif'}}>{card.name}</h3>
      
        <p>{card.rating}</p>
      <p>{card.title}</p>
      <p style={{color:'blue',fontFamily:'sans,serif'}}>{card.subheading}</p>

    </div>
    {/* <div className="info-details">
      <p  style={{color:'black',fontSize:'25px',fontFamily:'sans,serif'}}>Got Placed At</p>
     <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '-20px' }}>
  <img src={logoImage} alt="logo" className="logo" />
</div>


    </div> */}
  </button>
</div>
</div>
        ))}
      </div>

      <style>{`

.carousel {
           display: flex;
           overflow-x: hidden;
           gap: 30px;
           user-select: none;
           cursor: grab;
           width: 100%;
           margin: auto;
           max-width: 1400px;
          
         }

       .card {
           width: 280px;
           height: 320px;
           position: relative;   
            flex: 0 0 auto;
          
           overflow: hidden;
           box-shadow: 0 4px 10px rgba(0,0,0,0.1);
         }

        .card-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          position: absolute;
          top: 0;
          left: 0;
          transition: all 0.5s ease;
          z-index: 1;
        }

        .text-overlay {
          position: absolute;
          bottom: 0;
          width: 100%;
            background: rgb(255, 255, 255);
          // background: rgba(0, 0, 0, 0.4); /* semi-transparent black */

          color: blue;
          text-align: center;

 border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;


         
          z-index: 2;
        }

        .card-content {
          position: absolute;
          bottom: 20px;
          left: 20px;
          right: 20px;
          opacity: 0;
          z-index: 3;
          transition: all 0.5s ease;
          // background: rgba(255,255,255,0.95);
          background: transparent;

          padding: 15px;
          border-radius: 10px;
        }

        .card:hover .card-img {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          top: 20px;
          left: 20px;
          border:2px solid orange;
        }

        .card:hover .card-content {
          opacity: 1;
        }

       .info-button {
  background-color: transparent;
  border: 2px white;
  color: orange;
  width: 100%;
  padding: 10px;
  cursor: pointer;
  border-radius: 10px;
  transition: all 0.5s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  max-height: 60px;
}

.card:hover .info-button {
  max-height: 200px;
  padding: 20px 10px;
}

.info-header h3 {
  font-size: 16px;
  margin: 0;
  font-weight: bold;
}

.info-header p {
  font-size: 14px;
  margin: 2px 0;
}

.info-details {
  opacity: 0;
  transition: opacity 0.5s ease;
  text-align: center;
  margin-top: 10px;
}

.card:hover .info-details {
  opacity: 1;
}


.logo {
  width: 80px;
  height: 25px;
  margin-top: 5px;
}
      `}</style>
    </div>
  );
};

const styles = {
  wrapper: {
    overflow: 'hidden',
    padding: '20px',
    backgroundColor:'blue'
  },
  slider: {
    display: 'flex',
    gap: '20px',
    width: 'max-content',
  },
  card: {
    width: '300px',
    height: '320px',
    backgroundColor: '#fff',
    borderRadius: '15px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    position: 'relative',
    
  },
};

export default CoachProfiles;

